
import { computed, defineComponent } from "vue";
import { useStore } from "@/store";
import { OBTER_PROJETOS, REMOVER_PROJETO } from "@/store/tipos-acoes";

export default defineComponent({
  name: "ListaLista",
  methods: {
    excluir(id: string) {
      this.store.dispatch(REMOVER_PROJETO, id);
    },
  },

  setup() {
    const store = useStore()
    store.dispatch(OBTER_PROJETOS)
    return {
      projetos: computed(() => store.state.projeto.projetos),
      store
    };
  },
});
